// @ts-nocheck
import { createFileRoute } from "@tanstack/react-router";
import { useVelList } from "@/hooks/useVelList";
import { useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { NEW_BACKOFFICE_URL } from "@/lib/constants";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const vels = useVelList();

  if (!vels.length) {
    return <div>You have no access to any vel</div>;
  }

  return (
    <div className="m-4">
      <h1 className="font-bold text-5xl mb-8">Quel groupe de clubs?</h1>
      <ul>
        {vels.map((v) => {
          const isMigrated = v.migrated === 1;
          const handleClick = () => {
            if (isMigrated) {
              window.location.href = `${NEW_BACKOFFICE_URL}/vel/${v.id}`;
            } else {
              navigate({ to: `/vel/${v.id}` });
            }
          };

          return (
            <li key={v.id} className="mb-4">
              <Button
                variant="secondary"
                className="w-full py-6 cursor-pointer"
                onClick={handleClick}
              >
                <span className="flex items-center justify-between w-full">
                  <span>{v.name}</span>
                  {isMigrated && (
                    <span className="ml-2 px-2 py-1 bg-green-500 text-white text-xs rounded">
                      Nouveau backoffice
                    </span>
                  )}
                </span>
              </Button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
